import React from 'react';

import { Checkbox, FormControlLabel, Stack, TextField, Typography } from '@mui/material';

import type { EgsGuestCategoryDraft, EgsPackageOption } from './types';

interface Props {
  availablePackageOptions: Array<EgsPackageOption>;
  category: EgsGuestCategoryDraft;
  enabled: boolean;
  onChange: (changes: Partial<EgsGuestCategoryDraft>) => void;
}

export default function EgsUpgradeCostSection({ availablePackageOptions, category, enabled, onChange }: Props) {
  const showUpgradePackages = Number(category.upgradeNightlyCost) > 0;
  const hasPackageOptions = availablePackageOptions.length > 0;

  return (
    <>
      <TextField
        disabled={!enabled || !hasPackageOptions}
        helperText={hasPackageOptions ? undefined : 'No package options available yet'}
        label="Additional Nightly Cost for Upgrades"
        onChange={(event) => onChange({ upgradeNightlyCost: event.target.value })}
        size="small"
        type="number"
        value={category.upgradeNightlyCost}
      />

      {showUpgradePackages && (
        <Stack spacing={0.5}>
          <Typography color="text.secondary" variant="caption">
            Apply upgrade cost to package options
          </Typography>
          {hasPackageOptions ? (
            availablePackageOptions.map((option) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={category.upgradePackageOptions.includes(option.id)}
                    disabled={!enabled}
                    onChange={(event) => {
                      const next = event.target.checked
                        ? [...category.upgradePackageOptions, option.id]
                        : category.upgradePackageOptions.filter((id) => id !== option.id);
                      onChange({ upgradePackageOptions: next });
                    }}
                    size="small"
                  />
                }
                key={option.id}
                label={option.label}
              />
            ))
          ) : (
            <Typography color="text.secondary" fontStyle="italic" variant="caption">
              No package options found for this room.
            </Typography>
          )}
        </Stack>
      )}
    </>
  );
}
